import EventIcon from "@mui/icons-material/Event";
import BlockIcon from "@mui/icons-material/Block";
import PersonIcon from "@mui/icons-material/Person";

export const leadsAnalyticsMenu = [
  {
    key: "all-leads",
    label: "All Leads",
    icon: <PersonIcon />,
  },
  {
    key: "followups",
    label: "Follow-Ups",
    icon: <EventIcon />,
  },
  {
    key: "untouched",
    label: "Untouched",
    icon: <BlockIcon />,
  },
];
